const {flattenObject} = require('./Utils');

const SystemAction = {
    USER: {                             //Prefix: 0
        VIEW: '0-0',
        APPROVE: '0-1',
        DELETE: '0-2',
        CHANGE_ROLE: '0-3'
    },

    THEME: {                            //Prefix: 1
        CHANGE: '1-0',
        CREATE: '1-1'
    },

    PROJECT: {                          //Prefix: 2
        VIEW: '2-0',
        CREATE: '2-1',
        JOIN: '2-2',
        OVERRIDE: '2-3',
        DELETE: '2-4',

        TEMPLATE: {                     //Prefix: 2-5
            VIEW: '2-5-0',
            CREATE: '2-5-1',
            EDIT: '2-5-2',
            DELETE: '2-5-3',
            EDIT_DEFAULT: '2-5-4'
        },

        VIEW_ARCHIVED: '2-6',
        VIEW_OTHERS: '2-7'
    },

    ANNOUNCEMENT: {                     //Prefix: 3
        VIEW: '3-0',
        CREATE: '3-1',
        EDIT: '3-2',
        DELETE: '3-3',
        UNCLEAR_ALL: '3-4'
    },

    ROLE: {                             //Prefix: 4
        VIEW: '4-0',
        CREATE: '4-1',
        EDIT: '4-2',
        DELETE: '4-3'
    },

    VIEW_API_DOCS: '5-0',               //Prefix: 5
    CONFIG_DASHBOARD: '6-0',            //Prefix: 6,
    EDIT_KEY_BINDINGS: '7-0',           //Prefix: 7,

    LIBRARY: {                          //Prefix: 8
        FILE: {                         //Prefix: 8-0
            VIEW: '8-0-0',
            CREATE: '8-0-1',
            DOWNLOAD: '8-0-2',
            EDIT: '8-0-3',
            DELETE: '8-0-4',
        },

        MODEL: {                        //Prefix: 8-1
            VIEW: '8-1-0',
            CREATE: '8-1-1',
            DOWNLOAD: '8-1-2',
            EDIT: '8-1-3',
            DELETE: '8-1-4',
        },

        TAG: {                          //Prefix: 8-2
            VIEW: '8-2-0',
            CREATE: '8-2-1',
            DOWNLOAD: '8-2-2',
            EDIT: '8-2-3',
            DELETE: '8-2-4',
        },

        PANORAMIC_IMAGE: {              //Prefix: 8-3
            VIEW: '8-3-0',
            CREATE: '8-3-1',
            DOWNLOAD: '8-3-2',
            EDIT: '8-3-3',
            DELETE: '8-3-4',
        },

        PANORAMIC_VIDEO: {              //Prefix: 8-4
            VIEW: '8-4-0',
            CREATE: '8-4-1',
            DOWNLOAD: '8-4-2',
            EDIT: '8-4-3',
            DELETE: '8-4-4',
        },

        IMAGE: {                        //Prefix: 8-5
            VIEW: '8-5-0',
            CREATE: '8-5-1',
            DOWNLOAD: '8-5-2',
            EDIT: '8-5-3',
            DELETE: '8-5-4',
        },

        AUDIO: {                        //Prefix: 8-6
            VIEW: '8-6-0',
            CREATE: '8-6-1',
            DOWNLOAD: '8-6-2',
            EDIT: '8-6-3',
            DELETE: '8-6-4',
        },

        VIDEO: {                        //Prefix: 8-7
            VIEW: '8-7-0',
            CREATE: '8-7-1',
            DOWNLOAD: '8-7-2',
            EDIT: '8-7-3',
            DELETE: '8-7-4',
        },

        DOCUMENT: {                     //Prefix: 8-8
            VIEW: '8-8-0',
            CREATE: '8-8-1',
            DOWNLOAD: '8-8-2',
            EDIT: '8-8-3',
            DELETE: '8-8-4',
        },

        ENVIRONMENT: {                  //Prefix: 8-9
            VIEW: '8-9-0',
            CREATE: '8-9-1',
            DOWNLOAD: '8-9-2',
            EDIT: '8-9-3',
            DELETE: '8-9-4',
        },

        AVATAR: {                       //Prefix: 8-10
            VIEW: '8-10-0',
            CREATE: '8-10-1',
            DOWNLOAD: '8-10-2',
            EDIT: '8-10-3',
            DELETE: '8-10-4',
        },

        MODELLER: {                       //Prefix: 8-11
            VIEW: '8-11-0',
            CREATE: '8-11-1',
            DOWNLOAD: '8-11-2',
            EDIT: '8-11-3',
            DELETE: '8-11-4',
        }
    },

    EDIT_MEETING_SETTINGS: '9-0',       //Prefix: 9
    EDIT_GENERATION_SETTINGS: '10-0',   //Prefix: 10
    LOGIN_AS_USER: '11-0',              //Prefix: 11
    HELP_CENTER: {                      //Prefix: 10
        ISSUE_TRACKER: '12-0',
        ISSUE_CREATOR: '13-1'
    }
};

const SystemActionFlat = flattenObject(SystemAction);

module.exports = {
    SystemAction,
    SystemActionFlat
};
